import { createFileRoute } from "@tanstack/react-router";
import { SignUp } from "@clerk/react";

// Reached from a salon invitation email (sign-up is invitation-only in Clerk).
export const Route = createFileRoute("/sign-up/$")({
  component: () => (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <SignUp routing="path" path="/sign-up" />
    </div>
  ),
});
